import EditMobileUser from './EditMobileUser';

export default EditMobileUser;
